import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import oLocalStorage from '@/services/objectLocalStorage';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import _ from 'lodash';

Vue.use(Vuex);

const state = {
    langs: process.env.LANGUAGES,
    langSelected:
        oLocalStorage.get(keys.langSelected) !== null
            ? oLocalStorage.get(keys.langSelected)
            : process.env.LANGUAGES['en-GB'],
    headquarters: process.env.HEADQUARTERS,
    spanishCountries: process.env.SPANISH_COUNTRIES,
    country: 'ES',
    countryConstants: process.env.COUNTRY_CONSTANTS,
    countryConstantsSelected:
        oLocalStorage.get(keys.countryConstantsSelected) !== null
            ? oLocalStorage.get(keys.countryConstantsSelected)
            : process.env.COUNTRY_CONSTANTS['en'],

    cities: [
        {
            image: 'barcelona',
            name: 'Barcelona Provincia',
            action: 'https://barcelona.wesmartpark.com/es',
            urlCity: 'https://barcelona.wesmartpark.com',
            text: 'Barcelona Provincia',
            country: 'ES',
        },
        {
            image: 'madrid',
            name: 'Madrid',
            action: 'https://madrid.wesmartpark.com/es',
            urlCity: 'https://madrid.wesmartpark.com',
            text: 'Madrid',
            country: 'ES',
        },
        {
            image: 'lleida',
            name: 'Lleida',
            action: 'https://lleida.wesmartpark.com/es',
            urlCity: 'https://lleida.wesmartpark.com',
            text: 'LLeida',
            country: 'ES',
        },
        {
            image: 'santiago',
            name: 'Santiago',
            text: 'Santiago',
            country: 'CL',
        },
        {
            image: 'sao-paulo',
            name: 'Sao Paulo',
            text: 'Sao Paulo',
            country: 'BR',
        },
        {
            image: 'montevideo',
            name: 'Montevideo',
            text: 'Montevideo',
            country: 'UY',
        },
        {
            image: 'buenos-aires',
            name: 'Buenos Aires',
            text: 'Buenos Aires',
            country: 'AR',
        },
        {
            image: 'bogota',
            name: 'Bogotá',
            text: 'Bogotá',
            country: 'CO',
        },
        {
            image: 'mexico',
            name: 'México',
            text: 'México',
            country: 'MX',
        },
    ],
};

const mutations = {
    CHANGE_CITY_ORDER(state, country) {
        let tempCities = _.clone(state.cities);

        let citiesCountry = _.remove(tempCities, (item) => {
            return (
                item.country === country && typeof item.action !== 'undefined'
            );
        });

        state.cities = _.concat(citiesCountry, tempCities);

        let tempCountrySelected = {};
        if (_.isEmpty(citiesCountry)) {
            state.country = 'ES';
            tempCountrySelected = state.countryConstants['global'];
        } else {
            state.country = country;
            tempCountrySelected = state.countryConstants[country.toLowerCase()];
        }

        state.countryConstantsSelected = tempCountrySelected;
        oLocalStorage.set(
            keys.countryConstantsSelected,
            state.countryConstantsSelected
        );

        EventBus.$emit(keys.countrySelected, {});
    },

    CHANGE_LANG_SELECTED(state, item) {
        state.langSelected = state.langs[item.langSelected];
        oLocalStorage.set(keys.langSelected, state.langSelected);

        moment.locale(state.langSelected.lang);
        state.dateFormat = moment()
            .localeData()
            .longDateFormat('L')
            .replace('YYYY', 'yyyy')
            .replace('DD', 'dd');
        state.dateFormatTime = `${state.dateFormat} HH:mm`;

        EventBus.$emit(keys.eventOnLanguageChanged);
    },
};

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    keys,
    mutations,
});



// WEBPACK FOOTER //
// ./src/store/index.js